import { jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { AnalyticsId, IconSize } from "./constants.js";
import { palette } from "./theme/palette.js";
import { I as Icon } from "./Icon.js";
import Check from "./components/Icons/Check.js";
import styles from "./components/Avatar/styles.module.scss";
var AvatarSize = /* @__PURE__ */ ((AvatarSize2) => {
  AvatarSize2["xsmall"] = "xsmall";
  AvatarSize2["small"] = "small";
  return AvatarSize2;
})(AvatarSize || {});
const Avatar = React.forwardRef(function AvatarForwardedRef(props, ref) {
  const { children, className = "", selected = false, variant = "normal", type = "normal", size = "small", testId } = props;
  const truncatedName = children.charAt(0).toLocaleUpperCase() + children.substring(1, 2);
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: classNames(
        styles.avatar,
        selected && styles["avatar--selected"],
        variant === "black" && styles["avatar--black"],
        type === "circle" && styles["avatar--circle"],
        size === "xsmall" && styles["avatar--xsmall"],
        size === "small" && styles["avatar--small"],
        className
      ),
      ref,
      "data-testid": testId,
      "data-analyticsid": AnalyticsId.Avatar,
      children: selected ? /* @__PURE__ */ jsx(Icon, { svgIcon: Check, size: IconSize.Small, color: variant === "black" ? palette.neutral900 : palette.blueberry600 }) : truncatedName
    }
  );
});
export {
  Avatar as A,
  AvatarSize as a
};
//# sourceMappingURL=Avatar.js.map
